export const env = import.meta.env as ImportMetaEnv & {
  VITE_API_URL: string;
  VITE_IMAGE_BASE_URL: string;
  VITE_FROGGER_VERSION: string;
  VITE_ENV: string;
  VITE_FF_FLAG_STORE: string;
  VITE_FF_HIDE_MERCHFLOW_ACTION: string;
  /** Base URL of the POG agent service. Empty disables the POG agent chatbox. */
  VITE_POG_AGENT_URL: string;
};

export const isDev = () => env.VITE_ENV === "local" || env.VITE_ENV === "dev";

export const isProd = () => env.VITE_ENV === "production";

export const isMerchflowActionHidden = () => env.VITE_FF_HIDE_MERCHFLOW_ACTION === "true";
